import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { Duration } from 'luxon';
import { authService } from 'redux/utils/auth/authService';
import useIsAuthenticated from 'redux/utils/auth/isAuthenticatedHook';
import { getToken } from 'redux/utils/firebaseAuth.util';
import { useInactivityTimer } from './useInactivityTimer.hook';
import { Button } from '@act/storybook';

const formatTimeLeftSec = seconds => {
  return Duration.fromObject({ seconds: seconds }).toFormat('mm:ss');
};

const AutoLogout = () => {
  const isAuthenticated = useIsAuthenticated();

  const handleLogout = () => authService.logout();

  const { isWarning, timeLeftSec, resetTimer } =
    useInactivityTimer(handleLogout);
  const onClose = (event?: object, reason?: string) => {
    // Prevent closing via backdrop click or escape key - require explicit button click
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    resetTimer();
    void getToken(true); // force token refresh
  };

  if (!isAuthenticated) {
    return <></>;
  }

  return (
    <div>
      <Dialog open={isWarning} onClose={onClose}>
        <DialogTitle>
          <Typography variant="titleLarge">Automatic Logout</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="bodyMedium">
            Due to inactivity, you will automatically be logged out in{' '}
            {formatTimeLeftSec(timeLeftSec)}. To stay logged in, click anywhere
            on the screen or the appropriate button below.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            debounced
            onClick={e => {
              e.stopPropagation();
              onClose();
            }}
          >
            Stay logged in
          </Button>
          <Button
            debounced
            onClick={e => {
              e.stopPropagation();
              void handleLogout();
            }}
          >
            Log out now
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AutoLogout;
